module.exports = __webpack_public_path__ + "static/img/m6.9ee85e82.png";